import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId, organizedUnitId, includeDeleted = false) {
  const queryParamsArray = [
    `includeDeleted=${includeDeleted}`,
    `organizedUnitId=${organizedUnitId}`,
    `dossierSubTypeId=${dossierSubTypeId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )

  return apiFetch({ endPoint: 'brand' + queryParams, method: 'GET', body: null, token: token })
}
